import { getApi } from "./api_instance";

export const getAllWishlist = async ({ page, pageSize}, dispatch) => {
  try {

    return await getApi({
      apiUrl: `/projects/api/my-wishlist/getAllWishlist?page=${page}&pageSize=${pageSize}`,
      sendToken: true,
      dispatch, 
    });

  } catch (error) {
    throw error;
  }
};